// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contacts_wrapper__27fPS","menu":"Contacts_menu__1_BBe","icon":"Contacts_icon__1if2p"};